// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  /* Palette matches the shipped Massist Readiness product: warm paper, ink
     text, and a rotating accent set instead of a generic dark SaaS gradient. */
  --bg: #f2efe8;
  --panel: #fffdf9;
  --panel-2: #f7f2ea;
  --ink: #15171b;
  --ink-2: #4a4e57;
  --muted: #6f747d;
  --line: #e3ddd1;
  --line-2: #d1cabd;

  --orange: #c96a2f;
  --blue: #1d5c8f;
  --violet: #5567d8;
  --red: #be1622;
  --green: #16794f;
  --navy: #2c3d85;
  --teal: #0d7a7a;
  --gold: #a6791a;

  --orbit-radius: clamp(140px, 27vw, 230px);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  color: var(--ink);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  overflow-x: hidden;
}

.home h1,
.home h2,
.home h3 {
  font-family: 'Space Grotesk', 'Inter', sans-serif;
}

.accent-orange { --accent: var(--orange); }
.accent-blue { --accent: var(--blue); }
.accent-violet { --accent: var(--violet); }
.accent-red { --accent: var(--red); }
.accent-green { --accent: var(--green); }
.accent-navy { --accent: var(--navy); }
.accent-teal { --accent: var(--teal); }
.accent-gold { --accent: var(--gold); }

/* ---------- Nav ---------- */

.home-nav {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(242, 239, 232, 0.82);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--line);
}

.home-nav-inner {
  max-width: 1160px;
  margin: 0 auto;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
}

.home-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.home-nav-logo {
  height: 22px;
  width: auto;
  display: block;
}

.home-brand-divider {
  width: 1px;
  height: 18px;
  background: var(--line-2);
}

.home-brand-product {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14.5px;
  font-weight: 600;
  color: var(--ink-2);
}

.home-tabs {
  display: flex;
  gap: 2px;
  flex-wrap: wrap;
}

.home-tab {
  text-decoration: none;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--ink-2);
  padding: 8px 14px;
  border-radius: 8px;
  transition: background 0.15s ease, color 0.15s ease;
}

.home-tab:hover {
  background: var(--panel-2);
  color: var(--ink);
}

/* ---------- Hero ---------- */

.home-hero {
  position: relative;
  overflow: hidden;
  background: var(--bg);
}

.home-hero-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.hero-grid {
  position: absolute;
  inset: -10%;
  background-image:
    linear-gradient(rgba(21, 23, 27, 0.045) 1px, transparent 1px),
    linear-gradient(90deg, rgba(21, 23, 27, 0.045) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(ellipse 60% 55% at 50% 35%, #000 40%, transparent 78%);
}

.hero-blob {
  position: absolute;
  border-radius: 999px;
  filter: blur(70px);
  opacity: 0.35;
}

.hero-blob-a {
  width: 520px;
  height: 520px;
  top: -160px;
  left: 8%;
  background: radial-gradient(circle, rgba(29, 92, 143, 0.4), transparent 70%);
  animation: blob-drift-a 22s ease-in-out infinite;
}

.hero-blob-b {
  width: 460px;
  height: 460px;
  top: -80px;
  right: 6%;
  background: radial-gradient(circle, rgba(190, 22, 34, 0.22), transparent 70%);
  animation: blob-drift-b 26s ease-in-out infinite;
}

.hero-blob-c {
  width: 600px;
  height: 600px;
  bottom: -260px;
  left: 50%;
  transform: translateX(-50%);
  background: radial-gradient(circle, rgba(201, 106, 47, 0.28), transparent 70%);
  animation: blob-drift-c 30s ease-in-out infinite;
}

@keyframes blob-drift-a {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(60px, 40px) scale(1.12); }
}

@keyframes blob-drift-b {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-50px, 30px) scale(1.08); }
}

@keyframes blob-drift-c {
  0%, 100% { transform: translate(-50%, 0) scale(1); }
  50% { transform: translate(calc(-50% + 40px), -30px) scale(1.1); }
}

.home-hero-inner {
  position: relative;
  z-index: 1;
  max-width: 820px;
  margin: 0 auto;
  padding: 64px 24px 56px;
  text-align: center;
}

.home-kicker {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--orange);
  margin: 0 0 12px;
}

.home-hero h1 {
  font-size: 44px;
  line-height: 1.12;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 16px;
  color: var(--ink);
}

.home-hero-copy {
  font-size: 17px;
  line-height: 1.6;
  color: var(--ink-2);
  margin: 0;
}

/* ---------- Orbit ---------- */

.orbit-stage {
  position: relative;
  width: min(540px, 92vw);
  height: min(540px, 92vw);
  margin: 8px auto 8px;
}

.orbit-track {
  position: absolute;
  inset: 8%;
  border: 1.5px dashed var(--line-2);
  border-radius: 999px;
}

.orbit-core {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 999px;
  padding: 20px 28px;
  box-shadow: 0 10px 34px rgba(21, 23, 27, 0.12);
}

.orbit-core img {
  height: 36px;
  width: auto;
  display: block;
  position: relative;
  z-index: 1;
}

.orbit-core-ping {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  border: 1.5px solid var(--orange);
  animation: core-ping 3s ease-out infinite;
}

.orbit-core-ping-delay {
  animation-delay: 1.5s;
}

@keyframes core-ping {
  0% { transform: scale(1); opacity: 0.5; }
  100% { transform: scale(1.7); opacity: 0; }
}

.orbit-ring {
  position: absolute;
  inset: 0;
  animation: orbit-spin 64s linear infinite;
}

.orbit-stage:hover .orbit-ring,
.orbit-stage:hover .orbit-item-spin,
.orbit-stage:focus-within .orbit-ring,
.orbit-stage:focus-within .orbit-item-spin {
  animation-play-state: paused;
}

.orbit-stage:has(.orbit-badge:active) .orbit-ring,
.orbit-stage:has(.orbit-badge:active) .orbit-item-spin {
  animation-play-state: paused;
}

.orbit-spoke {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--orbit-radius);
  height: 1px;
  transform-origin: 0 50%;
  transform: rotate(var(--angle));
  background: linear-gradient(to right, rgba(201, 106, 47, 0.35), rgba(201, 106, 47, 0));
}

.orbit-spoke-dot {
  position: absolute;
  top: 50%;
  left: 0;
  width: 6px;
  height: 6px;
  margin-top: -3px;
  border-radius: 999px;
  background: var(--orange);
  box-shadow: 0 0 10px 3px rgba(201, 106, 47, 0.45);
  animation: spoke-travel 3.5s linear infinite;
}

@keyframes spoke-travel {
  0% { left: 0; opacity: 0; }
  12% { opacity: 1; }
  88% { opacity: 1; }
  100% { left: 100%; opacity: 0; }
}

.orbit-item {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform: rotate(var(--angle)) translateX(var(--orbit-radius));
}

.orbit-item-fix {
  transform: rotate(calc(-1 * var(--angle)));
}

.orbit-item-spin {
  animation: orbit-spin-reverse 64s linear infinite;
}

.orbit-badge {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 96px;
  padding: 14px 8px 12px;
  border-radius: 14px;
  background: var(--panel);
  box-shadow: 0 8px 18px rgba(21, 23, 27, 0.08);
  border: 1px solid var(--line);
  border-top: 2.5px solid var(--accent, var(--orange));
  text-decoration: none;
  color: var(--ink);
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.orbit-badge:hover,
.orbit-badge:focus-visible {
  transform: translate(-50%, -50%) scale(1.1);
  box-shadow: 0 14px 26px rgba(21, 23, 27, 0.16);
  outline: none;
}

.orbit-badge-icon {
  width: 22px;
  height: 22px;
  color: var(--accent, var(--orange));
}

.orbit-badge-label {
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  line-height: 1.25;
}

@keyframes orbit-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes orbit-spin-reverse {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}

/* ---------- Hero toast (proof-of-product snippet) ---------- */

.hero-toast {
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  margin: 4px auto 28px;
  padding: 12px 16px;
  max-width: 320px;
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(21, 23, 27, 0.08);
  text-align: left;
  animation: toast-float 5s ease-in-out infinite;
}

.hero-toast-dot {
  width: 8px;
  height: 8px;
  margin-top: 5px;
  border-radius: 999px;
  background: var(--orange);
  flex-shrink: 0;
  box-shadow: 0 0 0 3px rgba(201, 106, 47, 0.18);
}

.hero-toast-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--orange);
  margin-bottom: 2px;
}

.hero-toast-body {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--ink-2);
  line-height: 1.4;
}

@keyframes toast-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

@media (max-width: 640px) {
  .orbit-badge {
    width: 78px;
    padding: 10px 6px;
  }

  .orbit-badge-label {
    font-size: 10px;
  }

  .home-hero h1 {
    font-size: 30px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .orbit-ring,
  .orbit-item-spin,
  .hero-blob,
  .orbit-core-ping,
  .orbit-spoke-dot,
  .hero-toast {
    animation: none;
  }
}

/* ---------- Use-case grid ---------- */

.home-grid-section {
  background: var(--panel-2);
  border-top: 1px solid var(--line);
}

.home-grid-inner {
  max-width: 1160px;
  margin: 0 auto;
  width: 100%;
  padding: 56px 24px 72px;
  box-sizing: border-box;
}

.home-section-title {
  text-align: center;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  margin: 0 0 28px;
}

.home-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.home-card {
  flex: 1 1 300px;
  max-width: 350px;
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 26px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-top: 3px solid var(--accent, var(--orange));
  box-shadow: 0 4px 14px rgba(21, 23, 27, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.home-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 34px rgba(21, 23, 27, 0.1);
}

.home-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--panel-2);
  color: var(--accent, var(--orange));
}

.home-card-icon svg {
  width: 22px;
  height: 22px;
}

.home-card-body h3 {
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 6px;
  color: var(--ink);
}

.home-card-tagline {
  font-size: 14px;
  font-weight: 600;
  color: var(--accent, var(--orange));
  margin: 0 0 10px;
}

.home-card-description {
  font-size: 14px;
  line-height: 1.55;
  color: var(--ink-2);
  margin: 0;
}

.home-card-cta {
  margin-top: auto;
  align-self: flex-start;
  text-decoration: none;
  font-size: 13.5px;
  font-weight: 700;
  color: #ffffff;
  background: var(--ink);
  padding: 9px 16px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s ease, transform 0.12s ease;
}

.home-card-cta:hover {
  background: var(--accent, var(--orange));
  transform: translateY(-1px);
}

.home-card-cta span {
  transition: transform 0.15s ease;
}

.home-card-cta:hover span {
  transform: translateX(3px);
}

/* ---------- Footer ---------- */

.home-footer {
  border-top: 1px solid var(--line);
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: var(--bg);
}

.home-footer-logo {
  height: 20px;
  width: auto;
  opacity: 0.7;
}

.home-footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 20px;
}

.home-footer-links a {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-2);
  text-decoration: none;
}

.home-footer-links a:hover {
  color: var(--ink);
}

.home-footer-copyright {
  font-size: 12.5px;
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;EACE;+EAC6E;EAC7E,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,yGAAyG;EACzG,kBAAkB;AACpB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA,iBAAiB,uBAAuB,EAAE;AAC1C,eAAe,qBAAqB,EAAE;AACtC,iBAAiB,uBAAuB,EAAE;AAC1C,cAAc,oBAAoB,EAAE;AACpC,gBAAgB,sBAAsB,EAAE;AACxC,eAAe,qBAAqB,EAAE;AACtC,eAAe,qBAAqB,EAAE;AACtC,eAAe,qBAAqB,EAAE;;AAEtC,8BAA8B;;AAE9B;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;;wEAEsE;EACtE,0BAA0B;EAE1B,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,QAAQ;EACR,4EAA4E;EAC5E,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,6EAA6E;EAC7E,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,8EAA8E;EAC9E,gDAAgD;AAClD;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,WAAW,sCAAsC,EAAE;EACnD,MAAM,yDAAyD,EAAE;AACnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,KAAK,mBAAmB,EAAE,YAAY,EAAE;EACxC,OAAO,qBAAqB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,sFAAsF;AACxF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;EACE,KAAK,OAAO,EAAE,UAAU,EAAE;EAC1B,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,UAAU,EAAE;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,+DAA+D;AACjE;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,6CAA6C;EAC7C,6BAA6B;EAC7B,oDAAoD;EACpD,qBAAqB;EACrB,iBAAiB;EACjB,gFAAgF;AAClF;;AAEA;;EAEE,2CAA2C;EAC3C,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,0BAA0B,EAAE;AACnC;;AAEA,gEAAgE;;AAEhE;EACE,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA,wCAAwC;;AAExC;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kDAAkD;EAClD,6CAA6C;EAC7C,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;;AAEjC;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".home {\n  /* Palette matches the shipped Massist Readiness product: warm paper, ink\n     text, and a rotating accent set instead of a generic dark SaaS gradient. */\n  --bg: #f2efe8;\n  --panel: #fffdf9;\n  --panel-2: #f7f2ea;\n  --ink: #15171b;\n  --ink-2: #4a4e57;\n  --muted: #6f747d;\n  --line: #e3ddd1;\n  --line-2: #d1cabd;\n\n  --orange: #c96a2f;\n  --blue: #1d5c8f;\n  --violet: #5567d8;\n  --red: #be1622;\n  --green: #16794f;\n  --navy: #2c3d85;\n  --teal: #0d7a7a;\n  --gold: #a6791a;\n\n  --orbit-radius: clamp(140px, 27vw, 230px);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg);\n  color: var(--ink);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  overflow-x: hidden;\n}\n\n.home h1,\n.home h2,\n.home h3 {\n  font-family: 'Space Grotesk', 'Inter', sans-serif;\n}\n\n.accent-orange { --accent: var(--orange); }\n.accent-blue { --accent: var(--blue); }\n.accent-violet { --accent: var(--violet); }\n.accent-red { --accent: var(--red); }\n.accent-green { --accent: var(--green); }\n.accent-navy { --accent: var(--navy); }\n.accent-teal { --accent: var(--teal); }\n.accent-gold { --accent: var(--gold); }\n\n/* ---------- Nav ---------- */\n\n.home-nav {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: rgba(242, 239, 232, 0.82);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-bottom: 1px solid var(--line);\n}\n\n.home-nav-inner {\n  max-width: 1160px;\n  margin: 0 auto;\n  padding: 14px 24px;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n\n.home-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.home-nav-logo {\n  height: 22px;\n  width: auto;\n  display: block;\n}\n\n.home-brand-divider {\n  width: 1px;\n  height: 18px;\n  background: var(--line-2);\n}\n\n.home-brand-product {\n  font-family: 'Space Grotesk', sans-serif;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--ink-2);\n}\n\n.home-tabs {\n  display: flex;\n  gap: 2px;\n  flex-wrap: wrap;\n}\n\n.home-tab {\n  text-decoration: none;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--ink-2);\n  padding: 8px 14px;\n  border-radius: 8px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.home-tab:hover {\n  background: var(--panel-2);\n  color: var(--ink);\n}\n\n/* ---------- Hero ---------- */\n\n.home-hero {\n  position: relative;\n  overflow: hidden;\n  background: var(--bg);\n}\n\n.home-hero-bg {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.hero-grid {\n  position: absolute;\n  inset: -10%;\n  background-image:\n    linear-gradient(rgba(21, 23, 27, 0.045) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(21, 23, 27, 0.045) 1px, transparent 1px);\n  background-size: 42px 42px;\n  -webkit-mask-image: radial-gradient(ellipse 60% 55% at 50% 35%, #000 40%, transparent 78%);\n  mask-image: radial-gradient(ellipse 60% 55% at 50% 35%, #000 40%, transparent 78%);\n}\n\n.hero-blob {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(70px);\n  opacity: 0.35;\n}\n\n.hero-blob-a {\n  width: 520px;\n  height: 520px;\n  top: -160px;\n  left: 8%;\n  background: radial-gradient(circle, rgba(29, 92, 143, 0.4), transparent 70%);\n  animation: blob-drift-a 22s ease-in-out infinite;\n}\n\n.hero-blob-b {\n  width: 460px;\n  height: 460px;\n  top: -80px;\n  right: 6%;\n  background: radial-gradient(circle, rgba(190, 22, 34, 0.22), transparent 70%);\n  animation: blob-drift-b 26s ease-in-out infinite;\n}\n\n.hero-blob-c {\n  width: 600px;\n  height: 600px;\n  bottom: -260px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: radial-gradient(circle, rgba(201, 106, 47, 0.28), transparent 70%);\n  animation: blob-drift-c 30s ease-in-out infinite;\n}\n\n@keyframes blob-drift-a {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50% { transform: translate(60px, 40px) scale(1.12); }\n}\n\n@keyframes blob-drift-b {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50% { transform: translate(-50px, 30px) scale(1.08); }\n}\n\n@keyframes blob-drift-c {\n  0%, 100% { transform: translate(-50%, 0) scale(1); }\n  50% { transform: translate(calc(-50% + 40px), -30px) scale(1.1); }\n}\n\n.home-hero-inner {\n  position: relative;\n  z-index: 1;\n  max-width: 820px;\n  margin: 0 auto;\n  padding: 64px 24px 56px;\n  text-align: center;\n}\n\n.home-kicker {\n  font-family: 'Space Grotesk', sans-serif;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--orange);\n  margin: 0 0 12px;\n}\n\n.home-hero h1 {\n  font-size: 44px;\n  line-height: 1.12;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 0 0 16px;\n  color: var(--ink);\n}\n\n.home-hero-copy {\n  font-size: 17px;\n  line-height: 1.6;\n  color: var(--ink-2);\n  margin: 0;\n}\n\n/* ---------- Orbit ---------- */\n\n.orbit-stage {\n  position: relative;\n  width: min(540px, 92vw);\n  height: min(540px, 92vw);\n  margin: 8px auto 8px;\n}\n\n.orbit-track {\n  position: absolute;\n  inset: 8%;\n  border: 1.5px dashed var(--line-2);\n  border-radius: 999px;\n}\n\n.orbit-core {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  background: var(--panel);\n  border: 1px solid var(--line);\n  border-radius: 999px;\n  padding: 20px 28px;\n  box-shadow: 0 10px 34px rgba(21, 23, 27, 0.12);\n}\n\n.orbit-core img {\n  height: 36px;\n  width: auto;\n  display: block;\n  position: relative;\n  z-index: 1;\n}\n\n.orbit-core-ping {\n  position: absolute;\n  inset: 0;\n  border-radius: 999px;\n  border: 1.5px solid var(--orange);\n  animation: core-ping 3s ease-out infinite;\n}\n\n.orbit-core-ping-delay {\n  animation-delay: 1.5s;\n}\n\n@keyframes core-ping {\n  0% { transform: scale(1); opacity: 0.5; }\n  100% { transform: scale(1.7); opacity: 0; }\n}\n\n.orbit-ring {\n  position: absolute;\n  inset: 0;\n  animation: orbit-spin 64s linear infinite;\n}\n\n.orbit-stage:hover .orbit-ring,\n.orbit-stage:hover .orbit-item-spin,\n.orbit-stage:focus-within .orbit-ring,\n.orbit-stage:focus-within .orbit-item-spin {\n  animation-play-state: paused;\n}\n\n.orbit-stage:has(.orbit-badge:active) .orbit-ring,\n.orbit-stage:has(.orbit-badge:active) .orbit-item-spin {\n  animation-play-state: paused;\n}\n\n.orbit-spoke {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: var(--orbit-radius);\n  height: 1px;\n  transform-origin: 0 50%;\n  transform: rotate(var(--angle));\n  background: linear-gradient(to right, rgba(201, 106, 47, 0.35), rgba(201, 106, 47, 0));\n}\n\n.orbit-spoke-dot {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 6px;\n  height: 6px;\n  margin-top: -3px;\n  border-radius: 999px;\n  background: var(--orange);\n  box-shadow: 0 0 10px 3px rgba(201, 106, 47, 0.45);\n  animation: spoke-travel 3.5s linear infinite;\n}\n\n@keyframes spoke-travel {\n  0% { left: 0; opacity: 0; }\n  12% { opacity: 1; }\n  88% { opacity: 1; }\n  100% { left: 100%; opacity: 0; }\n}\n\n.orbit-item {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  transform: rotate(var(--angle)) translateX(var(--orbit-radius));\n}\n\n.orbit-item-fix {\n  transform: rotate(calc(-1 * var(--angle)));\n}\n\n.orbit-item-spin {\n  animation: orbit-spin-reverse 64s linear infinite;\n}\n\n.orbit-badge {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  width: 96px;\n  padding: 14px 8px 12px;\n  border-radius: 14px;\n  background: var(--panel);\n  box-shadow: 0 8px 18px rgba(21, 23, 27, 0.08);\n  border: 1px solid var(--line);\n  border-top: 2.5px solid var(--accent, var(--orange));\n  text-decoration: none;\n  color: var(--ink);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.orbit-badge:hover,\n.orbit-badge:focus-visible {\n  transform: translate(-50%, -50%) scale(1.1);\n  box-shadow: 0 14px 26px rgba(21, 23, 27, 0.16);\n  outline: none;\n}\n\n.orbit-badge-icon {\n  width: 22px;\n  height: 22px;\n  color: var(--accent, var(--orange));\n}\n\n.orbit-badge-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  line-height: 1.25;\n}\n\n@keyframes orbit-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes orbit-spin-reverse {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(-360deg); }\n}\n\n/* ---------- Hero toast (proof-of-product snippet) ---------- */\n\n.hero-toast {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 4px auto 28px;\n  padding: 12px 16px;\n  max-width: 320px;\n  background: var(--panel);\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  box-shadow: 0 10px 24px rgba(21, 23, 27, 0.08);\n  text-align: left;\n  animation: toast-float 5s ease-in-out infinite;\n}\n\n.hero-toast-dot {\n  width: 8px;\n  height: 8px;\n  margin-top: 5px;\n  border-radius: 999px;\n  background: var(--orange);\n  flex-shrink: 0;\n  box-shadow: 0 0 0 3px rgba(201, 106, 47, 0.18);\n}\n\n.hero-toast-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--orange);\n  margin-bottom: 2px;\n}\n\n.hero-toast-body {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--ink-2);\n  line-height: 1.4;\n}\n\n@keyframes toast-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n\n@media (max-width: 640px) {\n  .orbit-badge {\n    width: 78px;\n    padding: 10px 6px;\n  }\n\n  .orbit-badge-label {\n    font-size: 10px;\n  }\n\n  .home-hero h1 {\n    font-size: 30px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .orbit-ring,\n  .orbit-item-spin,\n  .hero-blob,\n  .orbit-core-ping,\n  .orbit-spoke-dot,\n  .hero-toast {\n    animation: none;\n  }\n}\n\n/* ---------- Use-case grid ---------- */\n\n.home-grid-section {\n  background: var(--panel-2);\n  border-top: 1px solid var(--line);\n}\n\n.home-grid-inner {\n  max-width: 1160px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 56px 24px 72px;\n  box-sizing: border-box;\n}\n\n.home-section-title {\n  text-align: center;\n  font-family: 'Space Grotesk', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--muted);\n  margin: 0 0 28px;\n}\n\n.home-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n}\n\n.home-card {\n  flex: 1 1 300px;\n  max-width: 350px;\n  background: var(--panel);\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  border-top: 3px solid var(--accent, var(--orange));\n  box-shadow: 0 4px 14px rgba(21, 23, 27, 0.05);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.home-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 34px rgba(21, 23, 27, 0.1);\n}\n\n.home-card-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--panel-2);\n  color: var(--accent, var(--orange));\n}\n\n.home-card-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.home-card-body h3 {\n  font-size: 19px;\n  font-weight: 700;\n  margin: 0 0 6px;\n  color: var(--ink);\n}\n\n.home-card-tagline {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--accent, var(--orange));\n  margin: 0 0 10px;\n}\n\n.home-card-description {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--ink-2);\n  margin: 0;\n}\n\n.home-card-cta {\n  margin-top: auto;\n  align-self: flex-start;\n  text-decoration: none;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #ffffff;\n  background: var(--ink);\n  padding: 9px 16px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background 0.15s ease, transform 0.12s ease;\n}\n\n.home-card-cta:hover {\n  background: var(--accent, var(--orange));\n  transform: translateY(-1px);\n}\n\n.home-card-cta span {\n  transition: transform 0.15s ease;\n}\n\n.home-card-cta:hover span {\n  transform: translateX(3px);\n}\n\n/* ---------- Footer ---------- */\n\n.home-footer {\n  border-top: 1px solid var(--line);\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  background: var(--bg);\n}\n\n.home-footer-logo {\n  height: 20px;\n  width: auto;\n  opacity: 0.7;\n}\n\n.home-footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px 20px;\n}\n\n.home-footer-links a {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-2);\n  text-decoration: none;\n}\n\n.home-footer-links a:hover {\n  color: var(--ink);\n}\n\n.home-footer-copyright {\n  font-size: 12.5px;\n  color: var(--muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
